import React, { memo } from 'react';
import { SortableElement } from 'react-sortable-hoc';

import { R } from '@core/utils/r';
import { openAddEditChecklistStep } from './AddEditChecklistStepModal';
import { ProjectChecklistId, ProjectChecklistStepResponse } from '@business/entities/project/';
import { openViewHTMLModal } from '@modules/common/ViewHTMLModal';
import { TableActions } from '@modules/common/TableActions';
import { HTMLService } from '@business/services';

export interface ChecklistStepItemProps {
  checklistId: ProjectChecklistId;
  onDelete(id: number): void;
  step: ProjectChecklistStepResponse;
}

export const CheckListStepItem = memo((props: ChecklistStepItemProps) => {
  const { checklistId, onDelete, step } = props;

  return (
    <>
      <div className="alert bg-light p-3 mb-1 d-flex flex-row" style={{ cursor: 'move' }}>
        <div className="d-flex align-items-center" style={{ flex: 1 }}>
          {R.isEmpty(step.link) && <span className="font-size-15 text-dark">{step.name}</span>}
          {!R.isEmpty(step.link) && (
            <a href={step.link} target={'_blank'} rel="noopener noreferrer" className="font-size-14 text-primary">
              {step.name}
            </a>
          )}
        </div>
        <div>
          <TableActions
            onDelete={() => onDelete(step.id)}
            onEdit={() => openAddEditChecklistStep({ checklistId, sectionId: step.id, step })}
            onView={
              R.isEmpty(HTMLService.strip(step.description || '').trim())
                ? undefined
                : () => openViewHTMLModal({ content: step.description || '<p></p>', title: step.name })
            }
          />
        </div>
      </div>
    </>
  );
});

export const SortableChecklistStepItem = SortableElement(CheckListStepItem);
